import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

import { pendingReviewSchemaProperty } from './pending-review';

export const userSourceAvailabilityScopes = ['global', 'note'] as const;
export type UserSourceAvailabilityScope = (typeof userSourceAvailabilityScopes)[number];

const userSourceSchemaLiteral = {
  title: 'userSource schema',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      maxLength: 36,
      type: 'string',
    },
    userId: { type: 'string' },

    name: { type: 'string' },
    content: { type: 'string' },
    parsedContent: { type: ['string', 'null'] }, // used to display content without HTML tags
    numTokens: { type: 'number' }, // token count for name+content
    // sourceType and source can be null if source is written from scratch by user
    sourceType: { type: ['string', 'null'] }, // ["text/markdown", "text/plain", "application/pdf", "url"]
    source: { type: ['string', 'null'] }, // URL or a storage path
    sourceDisplayName: { type: ['string', 'null'] }, // Display-only label for non-url sources (for example original file name)
    lastSyncAt: { type: 'string' }, // undefined if processing or written from scratch by user
    error: { type: 'string' },
    syncStatus: {
      type: 'string',
      enum: ['processing', 'ready', 'error'],
    },
    availabilityScope: {
      type: 'string',
      enum: userSourceAvailabilityScopes,
    },

    tagIds: {
      type: 'array',
      items: { type: 'string' },
    },
    pendingReview: pendingReviewSchemaProperty,

    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    archivedAt: { type: ['string', 'null'] },
    archived: { type: 'boolean' },
  },
  required: ['id', 'userId', 'name', 'content', 'createdAt', 'updatedAt', 'syncStatus', 'archived'],
  indexes: [['archived']],
} as const;
const _userSourceSchemaTyped = toTypedRxJsonSchema(userSourceSchemaLiteral);

export type UserSource = ExtractDocumentTypeFromTypedRxJsonSchema<typeof _userSourceSchemaTyped>;
export const userSourceSchema: RxJsonSchema<UserSource> = userSourceSchemaLiteral;
